import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    cardActionsRight: {
      display: 'flex',
      justifyContent: 'flex-end',
      margin: theme.spacing(1, 0, 1, 2)
    },
    cardActionButton: {
      margin: theme.spacing(0, 2, 0, 0)
    }
  })
